import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import SplitType from "split-type";

function gsapAnim(elements, toggleClass) {
    if (elements) {

        gsap.registerPlugin(ScrollTrigger);

        elements.forEach( (item) => {
            gsap.from(item, {
                scrollTrigger: {
					start: 'top bottom-=15%',
                    end: 'bottom top',
                    trigger: item,
                    scrub: true,
                    //markers: true,
                    toggleClass: toggleClass,
                    once: true
                }
            });
        })
    }
}

function gsapStaggerBlocksAnim(element) {
    if (element) {

        gsap.registerPlugin(ScrollTrigger);

        ScrollTrigger.batch(element, {
            onEnter: elements => {
                gsap.from(elements, {
                    autoAlpha: 0,
                    y: 50,
					duration: 1,
                    stagger: 0.15
                });
            },
            once: true
        });
    }
}

function headerTextIntroAnimation(elements) {
	if (elements) {
		let chars;
		elements.forEach(textLine => {
			const split = new SplitType(textLine, {
				types: 'lines, words, chars',
			})
			textLine.classList.remove('is-loading');
			chars = textLine.querySelectorAll('.char')
		})

		const tl = gsap.timeline();

		// char is class generated by Split Type
		tl.from(chars, {
			duration: 1,
			yPercent: -100,
			autoAlpha: 0,
			stagger: 0.01,
		});

		tl.from(".headerTagAnimation", {
			duration: 1,
			autoAlpha: 0,
		}, "+0.75");
	}
}

function sectionTitleIntroAnimation(elements) {
	if (elements) {

		elements.forEach( (item) => {

			const split = new SplitType(item, {
				types: 'lines, words, chars',
			})

			item.classList.remove('is-loading');

			gsap.from(item, {
				scrollTrigger: {
					start: 'top bottom-=15%',
					end: 'bottom top',
					trigger: item,
					scrub: true,
					//markers: true,
					once: true,
					onEnter: () => timelinePlayAnimations(),
				}
			});

			const tlTitleText = gsap.timeline({paused: true});

			const chars = item.querySelectorAll('.char')

			tlTitleText.from(chars, {
				duration: 1,
				yPercent: -100,
				autoAlpha: 0,
				stagger: 0.01,
			})

			function timelinePlayAnimations() {
				tlTitleText.play(0)
			}
		})
	}
}

window.addEventListener('load', () => {
	const fadeIns = gsap.utils.toArray('.fadeIn');
	const maskIns = gsap.utils.toArray('.maskInLeft');
    const slideInLefts = gsap.utils.toArray('.slideInLeft');
    const slideInRights = gsap.utils.toArray('.slideInRight');
    const slideInBottoms = gsap.utils.toArray('.slideInBottom');
    const headerTextAnimationTargets = gsap.utils.toArray('.headerTitleAnimation');
    const sectionTitleTextAnimationTargets = gsap.utils.toArray('.sectionTitleAnimation');

	gsapAnim(fadeIns, 'fade-in');
	gsapAnim(maskIns, 'mask-in-left');
    gsapAnim(slideInLefts, 'slide-in-left');
    gsapAnim(slideInRights, 'slide-in-right');
    gsapAnim(slideInBottoms, 'slide-in-bottom');
	headerTextIntroAnimation(headerTextAnimationTargets);
	sectionTitleIntroAnimation(sectionTitleTextAnimationTargets);
	gsapStaggerBlocksAnim('.slideInBottomStagger');
})
